export const ANALOG_CHANNELS = [
  {
  number: "2",
  name: "WGBH",
  displayName: "PBS",
  category: "Live PBS",
  type: "LIVE",
  streamUrl: "/pbs-live/channel-2.m3u8",
  logo: "/logos/pbs.png",
  programs: [
    {
      title: "PBS Live",
      start: "Now",
      end: "Live",
      width: 4,
      rating: "TV-G",
      genres: ["Public Television"],
      summary: "Live PBS programming.",
    },
  ],
},
{
  number: "4",
  name: "WBZ",
  category: "CBS",
  type: "HLS",
  sourceLabel: "Plex",
  preview: "https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?auto=format&fit=crop&w=1400&q=80",
  programs: [
    {
      title: "CBS",
      start: "8:00 PM",
      end: "12:30 AM",
      width: 9,
      rating: "TV-PG",
      genres: ["Comedy", "Sitcoms"],
      summary: "Live CBS-style sitcom block powered by Plex.",
    },
  ],
},
  {
    number: "5",
    name: "WCVB",
    category: "News",
    preview:
      "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "ABC News Live",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["News"],
        summary: "Live ABC news feed placeholder channel.",
      },
    ],
  },
  {
    number: "6",
    name: "WLNE",
    category: "Drama / Sitcom",
    preview:
      "https://images.unsplash.com/photo-1478720568477-152d9b164e26?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Modern Family",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "Sharp ABC sitcom block starter.",
      },
      {
        title: "Home Improvement",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Peak network sitcom nostalgia.",
      },
      {
        title: "Lost",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama", "Mystery"],
        summary: "Serialized ABC mystery prestige.",
      },
      {
        title: "Grey's Anatomy",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama"],
        summary: "Big emotional network drama.",
      },
      {
        title: "Twin Peaks",
        start: "11:00 PM",
        end: "12:30 AM",
        width: 3,
        rating: "TV-14",
        genres: ["Drama", "Mystery"],
        summary: "A weirder, moodier late-night turn.",
      },
    ],
  },
  {
    number: "7",
    name: "WHDH",
    category: "News",
    preview:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "NBC News NOW",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["News"],
        summary: "Live NBC news feed placeholder channel.",
      },
    ],
  },
  {
    number: "8",
    name: "WJAR",
    category: "Comedy / Drama / Late Night",
    preview:
      "https://images.unsplash.com/photo-1440404653325-ab127d49abc1?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Seinfeld",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "Pure NBC comfort.",
      },
      {
        title: "Frasier",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "Dry, smart network sitcom.",
      },
      {
        title: "The Office",
        start: "9:00 PM",
        end: "9:30 PM",
        width: 1,
        rating: "TV-14",
        genres: ["Comedy"],
        summary: "Modern NBC classic.",
      },
      {
        title: "Law & Order",
        start: "9:30 PM",
        end: "10:30 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Crime", "Drama"],
        summary: "The network procedural spine.",
      },
      {
        title: "Saturday Night Live",
        start: "10:30 PM",
        end: "12:00 AM",
        width: 3,
        rating: "TV-14",
        genres: ["Comedy", "Variety"],
        summary: "Late-night institution.",
      },
      {
        title: "The Tonight Show",
        start: "12:00 AM",
        end: "12:30 AM",
        width: 1,
        rating: "TV-14",
        genres: ["Talk"],
        summary: "Wraps the block with classic NBC late night.",
      },
    ],
  },
  {
    number: "9",
    name: "WSBE",
    category: "Arts / Calm",
    preview:
      "https://images.unsplash.com/photo-1460661419201-fd4cecdf8a8b?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Bob Ross Channel",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["Arts", "Calm"],
        summary: "The most relaxing thing in the entire lineup.",
      },
    ],
  },
  {
    number: "10",
    name: "WFXT",
    category: "Drama / Comedy / Animation",
    preview:
      "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "The Simpsons",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Animation", "Comedy"],
        summary: "Classic Fox comfort TV. Pure channel-surfing energy.",
      },
      {
        title: "Malcolm in the Middle",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "The frantic family sitcom block keeps rolling.",
      },
      {
        title: "House",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama"],
        summary: "Snark, puzzles, and network prestige.",
      },
      {
        title: "Fringe",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Sci-Fi", "Drama"],
        summary: "A weirder Fox primetime lane.",
      },
      {
        title: "Brooklyn Nine-Nine",
        start: "11:00 PM",
        end: "11:30 PM",
        width: 1,
        rating: "TV-14",
        genres: ["Comedy"],
        summary: "Sharp modern Fox-era comedy.",
      },
      {
        title: "Futurama",
        start: "11:30 PM",
        end: "12:30 AM",
        width: 2,
        rating: "TV-14",
        genres: ["Animation", "Comedy"],
        summary: "Animated late-night gold.",
      },
    ],
  },
  {
    number: "12",
    name: "WPRI",
    category: "Comedy / Drama",
    preview:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "How I Met Your Mother",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-14",
        genres: ["Comedy"],
        summary: "Comfort sitcom anchor.",
      },
      {
        title: "The Big Bang Theory",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "Big broad CBS sitcom energy.",
      },
      {
        title: "The Mentalist",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Crime", "Drama"],
        summary: "Glossy procedural comfort.",
      },
      {
        title: "Person of Interest",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama", "Thriller"],
        summary: "More serious CBS genre drama.",
      },
      {
        title: "Mom",
        start: "11:00 PM",
        end: "11:30 PM",
        width: 1,
        rating: "TV-14",
        genres: ["Comedy"],
        summary: "Modern CBS sitcom lane.",
      },
      {
        title: "Two and a Half Men",
        start: "11:30 PM",
        end: "12:30 AM",
        width: 2,
        rating: "TV-14",
        genres: ["Comedy"],
        summary: "Exactly the sort of rerun cable used to lean on.",
      },
    ],
  },
  {
    number: "13",
    name: "WNAC",
    category: "Comedy / Drama / Genre",
    preview:
      "https://images.unsplash.com/photo-1505685296765-3a2736de412f?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Family Guy",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-14",
        genres: ["Animation", "Comedy"],
        summary: "Fox alt-animation lane.",
      },
      {
        title: "Bob's Burgers",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-PG",
        genres: ["Animation", "Comedy"],
        summary: "Warm, weird, and funny.",
      },
      {
        title: "The X-Files",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Sci-Fi", "Drama"],
        summary: "Prime spooky Fox.",
      },
      {
        title: "Prison Break",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama", "Thriller"],
        summary: "Big serialized tension block.",
      },
      {
        title: "Glee",
        start: "11:00 PM",
        end: "12:00 AM",
        width: 2,
        rating: "TV-14",
        genres: ["Drama", "Music"],
        summary: "The absurd Fox wildcard.",
      },
      {
        title: "Married... with Children",
        start: "12:00 AM",
        end: "12:30 AM",
        width: 1,
        rating: "TV-PG",
        genres: ["Comedy"],
        summary: "A grimier, older-school comedy finish.",
      },
    ],
  },
  {
    number: "15",
    name: "CNN",
    category: "National News",
    preview:
      "https://images.unsplash.com/photo-1495020689067-958852a7765e?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "CNN Live",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["News"],
        summary: "Always-on national cable news.",
      },
    ],
  },
  {
    number: "19",
    name: "A&E Classic",
    category: "Crime / Documentary",
    preview:
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Biography",
        start: "8:00 PM",
        end: "9:00 PM",
        width: 2,
        rating: "TV-PG",
        genres: ["Documentary"],
        summary: "Old-school A&E identity.",
      },
      {
        title: "Cold Case Files",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Crime", "Documentary"],
        summary: "Prime crime-doc cable.",
      },
      {
        title: "American Justice",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Crime", "Documentary"],
        summary: "Narrated courtroom/doc energy.",
      },
      {
        title: "The First 48",
        start: "11:00 PM",
        end: "12:00 AM",
        width: 2,
        rating: "TV-14",
        genres: ["Crime"],
        summary: "A more modern true-crime turn.",
      },
      {
        title: "Intervention",
        start: "12:00 AM",
        end: "12:30 AM",
        width: 1,
        rating: "TV-14",
        genres: ["Reality", "Documentary"],
        summary: "The bridge into later A&E chaos.",
      },
    ],
  },
  {
    number: "20",
    name: "USA Network",
    category: "Action / Crime / Drama",
    preview:
      "https://images.unsplash.com/photo-1485846234645-a62644f84728?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Monk",
        start: "8:00 PM",
        end: "9:00 PM",
        width: 2,
        rating: "TV-PG",
        genres: ["Comedy", "Crime"],
        summary: "Peak USA comfort procedural.",
      },
      {
        title: "Psych",
        start: "9:00 PM",
        end: "10:00 PM",
        width: 2,
        rating: "TV-PG",
        genres: ["Comedy", "Crime"],
        summary: "Smart, goofy, USA blue-sky charm.",
      },
      {
        title: "Burn Notice",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Action", "Drama"],
        summary: "Sun-soaked cable espionage.",
      },
      {
        title: "White Collar",
        start: "11:00 PM",
        end: "12:00 AM",
        width: 2,
        rating: "TV-PG",
        genres: ["Crime", "Drama"],
        summary: "Exactly the kind of slick cable comfort show USA did well.",
      },
      {
        title: "WWF Raw Highlights",
        start: "12:00 AM",
        end: "12:30 AM",
        width: 1,
        rating: "TV-14",
        genres: ["Sports", "Entertainment"],
        summary: "A late-night attitude-era punch.",
      },
    ],
  },
  {
    number: "21",
    name: "TNT",
    category: "Drama / Sports / Movies",
    preview:
      "https://images.unsplash.com/photo-1517604931442-7e0c8ed2963c?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Classic 80s/90s Movie",
        start: "8:00 PM",
        end: "10:00 PM",
        width: 4,
        rating: "PG-13",
        genres: ["Movies"],
        summary: "The TNT movie lane is part of the nostalgia.",
      },
      {
        title: "Falling Skies",
        start: "10:00 PM",
        end: "11:00 PM",
        width: 2,
        rating: "TV-14",
        genres: ["Sci-Fi", "Drama"],
        summary: "Post-movie TNT drama block.",
      },
      {
        title: "Animal Kingdom",
        start: "11:00 PM",
        end: "12:00 AM",
        width: 2,
        rating: "TV-MA",
        genres: ["Drama"],
        summary: "Modern TNT prestige/crime flavor.",
      },
      {
        title: "WCW Monday Nitro Replay",
        start: "12:00 AM",
        end: "12:30 AM",
        width: 1,
        rating: "TV-14",
        genres: ["Sports", "Entertainment"],
        summary: "A little wrestling grime at the end of the night.",
      },
    ],
  },
  {
    number: "22",
    name: "ESPN",
    category: "Sports",
    preview:
      "https://images.unsplash.com/photo-1508098682722-e99c643e7485?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Sports",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["Sports"],
        summary: "Placeholder sports/live channel.",
      },
    ],
  },
  {
    number: "23",
    name: "NESN",
    category: "Regional Sports",
    preview:
      "https://images.unsplash.com/photo-1547347298-4074fc3086f0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Regional Sports",
        start: "8:00 PM",
        end: "12:30 AM",
        width: 9,
        rating: "TV-G",
        genres: ["Sports"],
        summary: "Placeholder regional sports channel.",
      },
    ],
  },
  {
    number: "24",
    name: "Nick Jr.",
    category: "Preschool / Kids",
    preview:
      "https://images.unsplash.com/photo-1512070679279-8988d32161be?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Blue's Clues",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "Bright, gentle preschool energy.",
      },
      {
        title: "Franklin",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "Quiet childhood comfort.",
      },
      {
        title: "Gullah Gullah Island",
        start: "9:00 PM",
        end: "9:30 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "Warm 90s kids TV memory lane.",
      },
      {
        title: "Eureeka's Castle",
        start: "9:30 PM",
        end: "10:00 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "A true old-school Nick Jr. vibe.",
      },
      {
        title: "Little Bear",
        start: "10:00 PM",
        end: "10:30 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "Soft, bedtime TV energy.",
      },
      {
        title: "Little Bill",
        start: "10:30 PM",
        end: "11:00 PM",
        width: 1,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "Gentle preschool block continuation.",
      },
      {
        title: "Nick Jr. Night Block",
        start: "11:00 PM",
        end: "12:30 AM",
        width: 3,
        rating: "TV-Y",
        genres: ["Kids"],
        summary: "A longer preschool-friendly rotation.",
      },
    ],
  },
  {
    number: "25",
    name: "Nickelodeon",
    category: "Kids / Teen",
    preview:
      "https://images.unsplash.com/photo-1512070679279-8988d32161be?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Doug",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-Y7",
        genres: ["Kids", "Animation"],
        summary: "Classic Nick starter.",
      },
      {
        title: "Hey Arnold!",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-Y7",
        genres: ["Kids", "Animation"],
        summary: "City-kid perfection.",
      },
      {
        title: "SpongeBob SquarePants",
        start: "9:00 PM",
        end: "9:30 PM",
        width: 1,
        rating: "TV-Y7",
        genres: ["Kids", "Animation"],
        summary: "The workhorse of the network.",
      },
      {
        title: "Drake & Josh",
        start: "9:30 PM",
        end: "10:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Prime Nickelodeon teen-comedy lane.",
      },
      {
        title: "iCarly",
        start: "10:00 PM",
        end: "10:30 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Web-era Nick chaos.",
      },
      {
        title: "Victorious",
        start: "10:30 PM",
        end: "11:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Teen ensemble mode.",
      },
      {
        title: "Nick Toons Block",
        start: "11:00 PM",
        end: "12:30 AM",
        width: 3,
        rating: "TV-Y7",
        genres: ["Animation"],
        summary: "A broader late-night Nick rotation.",
      },
    ],
  },
  {
    number: "26",
    name: "SNICK",
    category: "Saturday Night Block",
    preview:
      "https://images.unsplash.com/photo-1503455637927-730bce8583c0?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "Kenan & Kel",
        start: "8:00 PM",
        end: "8:30 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Orange soda territory.",
      },
      {
        title: "All That",
        start: "8:30 PM",
        end: "9:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy", "Sketch"],
        summary: "Peak SNICK variety energy.",
      },
      {
        title: "Are You Afraid of the Dark?",
        start: "9:00 PM",
        end: "9:30 PM",
        width: 1,
        rating: "TV-Y7",
        genres: ["Kids", "Horror"],
        summary: "The SNICK signature mood shift.",
      },
      {
        title: "The Secret World of Alex Mack",
        start: "9:30 PM",
        end: "10:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Drama", "Sci-Fi"],
        summary: "A perfect weird-90s Nickelodeon choice.",
      },
      {
        title: "Clarissa Explains It All",
        start: "10:00 PM",
        end: "10:30 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Classic Nick personality TV.",
      },
      {
        title: "The Adventures of Pete & Pete",
        start: "10:30 PM",
        end: "11:00 PM",
        width: 1,
        rating: "TV-G",
        genres: ["Comedy"],
        summary: "Indie-kid suburban surrealism.",
      },
      {
        title: "Rugrats / Ren & Stimpy Block",
        start: "11:00 PM",
        end: "12:30 AM",
        width: 3,
        rating: "TV-Y7",
        genres: ["Animation"],
        summary: "Animated late-night SNICK blend.",
      },
    ],
  },
];